import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-figma-benin-footer',
  templateUrl: './figma-benin-footer.component.html',
  styleUrls: ['./figma-benin-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FigmaBeninFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
